/**
 * Client-side type definitions for roles
 * This file doesn't import any server-only modules, making it safe for client components
 */

/**
 * User roles available in the application - client version
 */
export enum UserRole {
  CLIENTE = 'cliente',
  ADMINISTRADOR = 'administrador',
  REVENDEDOR = 'revendedor',
  EDITOR = 'editor',
  TITULAR = 'titular'
}

/**
 * Permissions available in the application - client version
 * Keep in sync with the server-side Permission enum
 */
export enum Permission {
  // Product permissions
  VIEW_PRODUCTS = 'view:products',
  CREATE_PRODUCT = 'create:product',
  EDIT_PRODUCT = 'edit:product',
  DELETE_PRODUCT = 'delete:product',
  
  // User permissions
  VIEW_USERS = 'view:users',
  CREATE_USER = 'create:user',
  EDIT_USER = 'edit:user',
  DELETE_USER = 'delete:user',
  USER_MANAGE = 'user:manage',
  MANAGE_ADMIN_ROLES = 'manage:admin_roles',
  
  // Order permissions
  VIEW_ORDERS = 'view:orders',
  MANAGE_ORDERS = 'manage:orders',
  
  // Quotation permissions
  VIEW_QUOTATIONS = 'view:quotations',
  MANAGE_QUOTATIONS = 'manage:quotations',
  
  // Admin dashboard
  VIEW_DASHBOARD = 'view:dashboard',
  VIEW_REPORTS = 'view:reports',
}

/**
 * Type for user data in the client
 */
export interface UserData {
  id: number;
  clerkId: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  role: string;
} 